<template lang="pug">
#modal-visualizacao-laudo
    el-dialog(
        :title="$t('mensagens.laudos.solicitacaoDeLaudo')",
        width='500px',
        :visible='show',
        @close='closeDialog()'
    )
        .mapa
            Mapa(
                :mapLayersConfigs='layersMaps',
                :mapConfig='mapConfig',
                :height='"100%"',
                :idMapa='"mapaVizualizacaoLaudo"',
                locked
            )

        p
            b {{ $t('mensagens.laudos.territorio') }}:
            |
            | {{ informacoesLaudo.nomeTerritorio }}
        p
            b {{ $t('mensagens.laudos.localidade') }}:
            |
            | {{ informacoesLaudo.localidadeTerritorio ? informacoesLaudo.localidadeTerritorio.localidadeFormatada : null }}
        p
            b CAR:
            |
            | {{ informacoesLaudo.car ? informacoesLaudo.car.codigo : null }}
        p.margin-p
            b {{ $t('mensagens.laudos.pessoaS') }}:
            ul.lista-cliente
                li.lista(v-for='rep in informacoesLaudo.representantes')
                    span {{ rep.nomeRepresentante }} - {{ $t('mensagens.comuns.documento') }}: {{ numeralStringFormatTocpfCnpj(rep.cpfCnpjRepresentante) }}

        BaseButton(slot='footer', size='mini', @click='closeDialog()') {{ $t('mensagens.comuns.voltar') }}
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import LaudosService from '@/services/LaudosService';
import formatters from '@/utils/formatters';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalVisualizacaoLaudo',

    components: {
        Mapa,
        BaseButton
    },

    props: {
        idLaudo: {
            type: Number | null,
            required: true
        },
        show: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            informacoesLaudo: {
                municipioTerritorio: {
                    estado: {}
                },
                produtividadeEsperadaScHa: 0,
                areaFinanciadaHa: 0,
                producaoEsperada: 0,
                cpfCnpjRepresentante: '00000000000',
                culturaEsperada: {}
            },

            layersMaps: [],
            mapConfig: {
                controls: {}
            }
        };
    },

    methods: {
        getInformacoes() {
            if (!this.idLaudo) {
                return null;
            }
            LaudosService.getInformacoesByIdLaudo(this.idLaudo)
                .then(({ data }) => {
                    this.informacoesLaudo = data;
                    setTimeout(() => this.mostrarTerritorioNoMapa(), 500);
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.laudos.erro.naoFoiPossivelBuscarAsInformacoesDoLaudo')
                    });
                });
        },

        numeralStringFormatTocpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },

        formatNumber(number) {
            return formatters.formatNumber(number, 2);
        },

        mostrarTerritorioNoMapa() {
            this.layersMaps = [];

            let layerTerritorio = {
                style: getEstiloGeometria('area'),
                name: 'Território Laudo',
                geoJson: this.informacoesLaudo.geometriaTerritorio
            };

            this.layersMaps.push(layerTerritorio);
        },

        closeDialog() {
            this.$emit('update:show', false);
        }
    },

    watch: {
        idLaudo: function () {
            this.getInformacoes();
        }
    },

    created() {
        this.getInformacoes();
    }
};
</script>

<style lang="scss">
#modal-visualizacao-laudo {
    .el-dialog__footer {
        margin-top: 0px;
        display: flex;
        justify-content: flex-start;
    }

    .mapa {
        height: 150px;
        border-radius: 4px;
        overflow: hidden;
        margin: 0 0 20px 0
    }

    .margin-p {
        margin-bottom: 0;
    }

    ul.lista-cliente {
        overflow: auto;
        max-height: 130px;
    }

    .lista-cliente {
        @include scroll-bar();
        list-style: none;
        padding-inline-start: 0px;
        margin: 0;
        padding: 0;

        li {
            margin-bottom: 2px;
        }
    }
}
</style>
